import Loadable from '@loadable/component';

const WorkflowList = Loadable(async () => import('./components/workflow-list'));
const WorkflowEdit = Loadable(async () => import('./components/workflow-edit'));

const workflowRoutes = {
  '/workflows': {
    components: { main: WorkflowList },
    '/:workflowId': {
      components: { main: WorkflowEdit }
    }
  }
};

export default workflowRoutes;
